import {
    Breakpoints,
    Card,
    Image,
    TextTag,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import {globalColors} from '@volkswagen-onehub/tokens'
import styled from 'styled-components'
import React from 'react'
import isEmpty from 'lodash.isempty'
import {
    showSimulationByAdvance,
    showSimulationByMonthlyRange,
} from '../../shared/utilities'
import {SimulationAccordion} from './SimulationAccordion'
import {SingleSimulation} from '../../types/SingleSimulation'
import {ModelName} from './ModelName'

const CustomCard = styled(Card)`
    box-shadow: ${({theme}) => theme.colors.shadow.smallHover};
    height: max-content;

    &:hover {
        box-shadow: ${({theme}) => theme.colors.shadow.smallHover} !important;
    }
`

const CardHero = styled.div`
    position: relative;
    height: ${(props) => props.theme.size.static1000};
    padding-top: ${(props) => props.theme.size.dynamic0050};
    padding-left: ${(props) => props.theme.size.dynamic0050};
    padding-right: ${(props) => props.theme.size.dynamic0050};
    margin-bottom: ${(props) => props.theme.size.dynamic0140};
    background-color: ${globalColors.newHorizon[40]};

    @media (min-width: ${Breakpoints.b2560}px) {
        height: ${(props) => props.theme.size.static1200};
    }
`

const CardImage = styled(Image)`
    position: absolute;
    bottom: -25%;
    left: 0;
`

const SimulationsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`

interface ModelCardProps {
    modelData: any
}

export function ModelCard(props: ModelCardProps): React.JSX.Element {
    return (
        <CustomCard>
            {!isEmpty(props.modelData) ? (
                <>
                    <CardHero>
                        <ModelName
                            model={props.modelData.name}
                            bigger={false}
                            tag={TextTag.h3}
                            color={TokenTextColor.primary}
                        />

                        <CardImage src={props.modelData.imageListing} alt="" />
                    </CardHero>
                </>
            ) : undefined}

            {!isEmpty(props.modelData.data) ? (
                <>
                    <SimulationsList>
                        {props.modelData.data.simulations.map(
                            (promo: SingleSimulation, index: number) =>
                                !isEmpty(props.modelData.data) &&
                                showSimulationByAdvance(promo) &&
                                showSimulationByMonthlyRange(promo) ? (
                                    <SimulationAccordion
                                        key={index}
                                        index={index}
                                        modelName={props.modelData.name}
                                        promoData={promo}
                                        infoUrl={
                                            props.modelData.data.info_cta_url
                                        }
                                        image={props.modelData.imageListing}
                                        singleModel={false}
                                        infoUrlPassThrough={
                                            props.modelData
                                                .infoCtaUrlParamsPassThrough
                                        }
                                    />
                                ) : undefined
                        )}
                    </SimulationsList>
                </>
            ) : undefined}
        </CustomCard>
    )
}
